import React, { FC, useState } from "react";

import { IInterviewQuestion } from "../../../../interfaces/services";
import { ICommonScanCriteria } from "../../../../interfaces/scan_criterias";
import { ICommonCriteriaPoint } from "../../../../interfaces/criteria_points";

import ResultLayout from "../../../layouts/Result";
import QuestionScoreCard from "./QuestionScoreCard";
import ResultContainer from "../../../reusables/results/ResultContainer";

interface IInterviewResultsProps {
    studentId: number;
    interviewTitle: string;
    interviewMode: string;
    interviewQuestions: IInterviewQuestion[];
}

const InterviewResults: FC<IInterviewResultsProps> = (props) => {
    const { studentId, interviewTitle, interviewMode, interviewQuestions } = props;
    // const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);

    const currentQuestion = interviewQuestions[currentQuestionIndex];
    const totalQuestions = interviewQuestions.length;

    const handleNextQuestion = () => {
        if (currentQuestionIndex < totalQuestions - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handlePreviousQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const commonScanCriterias = currentQuestion.interview_scan_criterias.map(
        (scanCriteria) => {
            const level = scanCriteria.level === 3 ? scanCriteria.level + 1 : scanCriteria.level;
            const commonScanCriteria: ICommonScanCriteria = {
                id: scanCriteria.id,
                title: scanCriteria.title,
                description: scanCriteria.description,
                type: scanCriteria.type,
                level: level,
                criteria_points: scanCriteria.criteria_points.map((criteriaPoint) => {
                    const level = criteriaPoint.interview_result.level === 3 ? criteriaPoint.interview_result.level + 1 : criteriaPoint.interview_result.level;
                    const commonCriteriaPoint: ICommonCriteriaPoint = {
                        id: criteriaPoint.id,
                        scan_criteria_id: criteriaPoint.scan_criteria_id,
                        title: criteriaPoint.title,
                        description: criteriaPoint.description,
                        result: {
                            level: level,
                            review: criteriaPoint.interview_result.ai_review,
                            score: criteriaPoint.interview_result.score,
                        },
                    };

                    return commonCriteriaPoint;
                }),
            };

            return commonScanCriteria;
        }
    );

    return (
        <ResultLayout
            title={interviewTitle}
            onTitleClick={() => { }}
        // onTitleClick={() => setIsDrawerOpen(true)}
        >
            <QuestionScoreCard
                studentId={studentId}
                mediaId={currentQuestion?.media?.id ?? 0}
                score={currentQuestion?.score ?? 0}
                question={currentQuestion}
                totalQuestions={totalQuestions}
                interviewTitle={interviewTitle}
                interviewMode={interviewMode}
                onNextQuestion={handleNextQuestion}
                onPreviousQuestion={handlePreviousQuestion}
            />

            <ResultContainer scanCriterias={commonScanCriterias} />

            {/* <Drawer
                isOpen={isDrawerOpen}
                title="Richard Jaff_Resume"
                onClose={() => setIsDrawerOpen(false)}
                closeIcon={Icons.Cross}
            >
                <ImageAsset src={MockImg} alt="Resume preview" className="immersion__drawer_preview_img" />
            </Drawer> */}
        </ResultLayout>
    );
};

export default InterviewResults;